import React from 'react';

const noData = () => {
    return (
        <div className="no-data mt-lg-8 mb-lg-8 mt-md-4 mb-md-3">
            <i className="ico ico-nodata"></i>
            <p className="mt-md-0">There are no search results.</p>
        </div>
    )
}

export default noData;